function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7498 14.5833H16.3332L15.0453 13.2955C14.6961 12.9462 14.4998 12.4725 14.4998 11.9786V9.08334C14.4998 6.6886 12.9694 4.65133 10.8332 3.8963V3.58333C10.8332 2.57081 10.0124 1.75 8.99984 1.75C7.98731 1.75 7.1665 2.57081 7.1665 3.58333V3.8963C5.03032 4.65133 3.49984 6.6886 3.49984 9.08334V11.9786C3.49984 12.4725 3.30362 12.9462 2.95436 13.2955L1.6665 14.5833H6.24984M11.7498 14.5833V15.5C11.7498 17.0188 10.5186 18.25 8.99984 18.25C7.48105 18.25 6.24984 17.0188 6.24984 15.5V14.5833M11.7498 14.5833H6.24984",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgBellThick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellThick);
export default __webpack_public_path__ + "static/media/bell-thick.a4667abd.svg";
export { ForwardRef as ReactComponent };